/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from './vuetify'
import pinia from '../stores'
import router from '../router'
import { startMaintenanceEnforcement } from './maintenance'
import { startFeatureUsage } from './featureUsage'

// Services
import { appClients } from '@/services/appClients'
import { provideClients } from '@/services/clients'
import { setRouter } from '@/services/navigation'
import { createFirebaseRemoteConfig } from '@/services/appRemoteConfig'
import { provideRemoteConfig, setDefaultRemoteConfig } from '@/services/remoteConfig'

// Types
import type { App } from 'vue'

export function registerPlugins (app: App) {
  app
    .use(vuetify)
    .use(router)
    .use(pinia)

  // Lets stores navigate without importing the router singleton.
  setRouter(router)

  // Pinia must be installed first: the transport's store accessors resolve
  // useAuthStore() on the active Pinia instance.
  provideClients(app, appClients)

  // Must run before any store that reads it is instantiated, or the store
  // would resolve the inactive fallback and never see a maintenance.
  const remoteConfig = createFirebaseRemoteConfig()
  provideRemoteConfig(app, remoteConfig)
  setDefaultRemoteConfig(remoteConfig)

  startMaintenanceEnforcement(router)
  startFeatureUsage()
}
